var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSettings = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.333a2.667 2.667 0 110 5.334 2.667 2.667 0 010-5.334zm0 1.334a1.333 1.333 0 100 2.666 1.333 1.333 0 000-2.666zm-1.333 8a.337.337 0 01-.334-.28l-.246-1.767a4.627 4.627 0 01-1.127-.66l-1.66.673a.335.335 0 01-.407-.146L.56 9.18a.329.329 0 01.08-.427l1.407-1.106L2 7l.047-.667L.64 5.247a.329.329 0 01-.08-.427l1.333-2.307a.328.328 0 01.407-.146l1.66.666c.347-.26.707-.486 1.127-.653L5.333.613a.337.337 0 01.334-.28h2.666c.167 0 .307.12.334.28l.246 1.767c.42.167.78.393 1.127.653l1.66-.666c.147-.06.327 0 .407.146L13.44 4.82a.329.329 0 01-.08.427l-1.407 1.086L12 7l-.047.667 1.407 1.086c.127.1.167.28.08.427l-1.333 2.307a.328.328 0 01-.407.146l-1.66-.666a4.83 4.83 0 01-1.127.653l-.246 1.767a.337.337 0 01-.334.28H5.667zm.833-12l-.247 1.74c-.8.166-1.506.593-2.02 1.186L2.627 3.9l-.5.867L3.533 5.8a3.7 3.7 0 000 2.4L2.12 9.24l.5.867 1.62-.694a3.63 3.63 0 002.007 1.174l.246 1.746h1.014l.246-1.74a3.679 3.679 0 002.007-1.18l1.62.694.5-.867-1.413-1.033a3.72 3.72 0 000-2.407l1.406-1.033-.5-.867-1.606.693a3.614 3.614 0 00-2.02-1.18L7.5 1.667h-1z"
  })));
};
export default SvgSettings;